"use client"; 

import { useState, useEffect } from 'react'
import AppLogo from '../apps/logo';
import SectionMoreButton from '../common/sectionMoreButton';


export default function SourceUpdatesNewAppsBlock(
  { app, items, options, messages }: 
  { app: any, items: any, options?: any, messages?: any }
) {

const { chunk } = options

const [page, setPage] = useState(1)  // Using to load more apps
const [itemsVisible, setItemsVisible] = useState(items?.slice(0, chunk)) 

useEffect(() => {
  setItemsVisible(items?.slice(0, chunk*page))  
}, [page]);


const showCardFooter = (x) => {
  return x?.description || x?.triggersSentense || x?.actionsSentense
}


return (
    <div className="space-y-6">
      <ul role="list" className="space-y-6">
        {itemsVisible?.map((item, index) => (
          <li key={index} className=" bg-white border border-gray-200 rounded divide-y">

            <div className="flex w-full items-center justify-between space-x-3 px-3 py-2">
                    
              {item?.app?.image_updated_at ? (
                <AppLogo app={item?.app} className="h-12 w-12 rounded-fulld" />
              ) : (
                <span 
                  className="inline-flex h-12 w-12 items-center justify-center rounded-full "                  
                  style={{ backgroundColor: item?.app?.color ? `#${item?.app?.color}` : "#D4D4D4" }} // bg-gray-300
                >
                  <span className="text-lg font-medium leading-none text-white">
                    {item?.app?.name?.slice(0,1)?.toUpperCase()}
                  </span>
                </span>
              )}


              <div className="flex-1 space-y-0">
                <p className="">
                  {item?.title}                         
                </p>
                <p className="text-gray-500">
                  {item?.created_relative}
                </p>    
              </div>

              <div className="flex-none">

                <p>
                  {item?.app?.slug ? (
                    <a href={`/${item?.app?.slug}`} className="text-sm font-semibold text-crisp-600">
                      {messages?.viewProfile} <span aria-hidden="true">→</span>
                    </a>
                  ) : null}
                </p>
              </div>

            </div>
            

            {/* Card Footer */}
            {showCardFooter(item) ? (
              <div className="px-3 py-2 bg-gray-200/30 text-gray-600 text-base space-y-2">
                
                <div className="space-x-2">
                  {[ 
                    { id: 1, title: item?.count_triggers_label }, 
                    { id: 2, title: item?.count_actions_label }, 
                  ]?.filter(x => x?.title)?.map(x => (
                    <span
                      key={x.id}
                      
                      className="relative inline-flex items-center rounded-full px-2.5 py-1 text-xs ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                    >
                      <span className="absolute flex flex-shrink-0 items-center justify-center">
                        <span
                          className="h-1.5 w-1.5 rounded-full bg-crisp-400"
                          aria-hidden="true"
                        />
                      </span>
                      <span className="ml-3 font-semibold text-gray-900">
                        {x?.title}
                      </span>
                      
                    </span>
                  ))}                  
                </div>


                {item?.description ? (
                  <p className="">
                    {item?.description}
                  </p>
                ) : null}
                

                {item?.triggersSentense || item?.actionsSentense ? (
                  <p className="text-sm">
                    {item?.triggersSentense}
                    {item?.triggersSentense ? ` ` : null}
                    {item?.actionsSentense}
                  </p>
                ) : null}              

              </div>
            ) : null}
          </li>
        ))}
      </ul>    
      
      {chunk*page < items?.length ? (
        <SectionMoreButton 
          title={messages?.showMore} 
          onClick={() => setPage(page+1)} 
        />
      ) : null}
    </div>
  )

}

